import request from '@/router/axios'

export function fetchNewsList(query) {
  return request({
    url: '/news/news/admin/page',
    method: 'get',
    params: query
  })
}

export function getNewsById(id) {
  return request({
    url: '/news/news/' + id,
    method: 'get'
  })
}

export function getNewsDetailById(id) {
  return request({
    url: '/news/news/' + id + '/admin/details',
    method: 'get'
  })
}

export function addNews(obj) {
  return request({
    url: '/news/news/admin',
    method: 'post',
    data: obj
  })
}

export function delNewsBy(id) {
  return request({
    url: '/news/news/' + id,
    method: 'delete'
  })
}

export function putBasicNews(params) {
  return request({
    url: '/news/news/' + params.newsId + '/' + params.isBanned,
    method: 'put'
  })
}

export function putNews(obj) {
  return request({
    url: '/news/news',
    method: 'put',
    data: obj
  })
}

export function delNewsSources(id) {
  return request({
    url: '/news/articles/' + id,
    method: 'delete'
  })
}

export function addNewsSource(params) {
  return request({
    url: '/news/news/source',
    method: 'post',
    data: params
  })
}

export function getRelatedNews(query, newsId) {
  return request({
    url: '/news/news/' + newsId + '/admin/relatedNews',
    method: 'get',
    params: query
  })
}

export function delRelatedNews(newsId, relatedNewsId) {
  return request({
    url: '/news/news/' + newsId + '/admin/relatedNews/' + relatedNewsId,
    method: 'delete',
  })
}

export function addRelatedNews(obj) {
  return request({
    url: '/news/news/admin/relatedNews',
    method: 'post',
    data: obj
  })
}

export function getAddRelatedNewsPage(query, newsId) {
  return request({
    url: '/news/news/' + newsId + '/admin/addRelatedNewsPage',
    method: 'get',
    params: query
  })
}